import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { apiGet, withQuery } from "@amber/ui";
import { searchResponseSchema } from "@amber/application/contracts";
import { evidenceKeys } from "@amber/evidence/ui";
import type { SearchPageSearch } from "./params";

export const searchQuery = (params: SearchPageSearch & { q: string }, limit: number) =>
  queryOptions({
    queryKey: evidenceKeys.search(params, limit),
    queryFn: ({ signal }) =>
      apiGet(withQuery("/api/search", { ...params, limit: String(limit) }), searchResponseSchema, signal),
    enabled: params.q.trim().length > 0,
    placeholderData: keepPreviousData,
    staleTime: 10_000,
  });
